import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { dataGet } from "../network";
import { verifyIdentity } from "../network/const";
// import { RenderHeader } from "../components/structure/Header";
// import { RenderMenu, RenderRoutes } from "../components/structure/RenderNavigation";

type errorType = {
  error: boolean;
  errorType: "success" | "warning" | "error" | null;
  errorTitle: string;
  errorDescription: string;
  hide?: boolean;
  code?: number;
};
type AuthContextType = {
  user: any;
  error: errorType;
  identity: any;
  setIdentity: (identity: any) => void;
  login: (data: any) => void;
  logout: () => void;
  setError: (error: errorType) => void; // Directly pass the object instead of destructuring
};

type AuthWrapperProps = {
  children: React.ReactNode;
};
const AuthContext = createContext<AuthContextType | null>(null);
export const AuthData = () => useContext(AuthContext);

export const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const [user, setUser] = useState({
    name: "",
    isAuthenticated: false,
    email: "",
    token: "",
  });
  const [identity, setIdentity] = useState<any>(null);
  const [loading, setLoading] = useState(true); // NEW

  const [error, setError] = useState<errorType>({
    error: false,
    errorType: null,
    errorDescription: "",
    errorTitle: "",
  });

  const logout = useCallback(() => {
    setUser({ ...user, isAuthenticated: false, token: "" });
    setIdentity(null);
    localStorage.removeItem("user");
    localStorage.removeItem("identity");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Add `user` as a dependency, since you're using `user` in `setUser`

  // Your identity fetching function using dataGet and verifyIdentity endpoint
  const fetchAndStoreIdentity = useCallback(async () => {
    try {
      const identityResponse = await dataGet(verifyIdentity, {});
      if (identityResponse?.status) {
        setIdentity(identityResponse.data);
        localStorage.setItem("identity", JSON.stringify(identityResponse.data));
      } else {
        console.error("Failed to fetch identity", identityResponse);
        // Handle error, optionally logout if unauthorized:
        if (identityResponse?.code === 401) {
          logout();
        }
      }
    } catch (err) {
      console.error("Error fetching identity", err);
      logout();
    }
  }, [logout]);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const { username, email, token } = JSON.parse(storedUser);
      setUser({
        name: username,
        email,
        isAuthenticated: true,
        token,
      });

      // Call your fetchAndStoreIdentity on mount once user is set
      fetchAndStoreIdentity().finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [fetchAndStoreIdentity]);
  // useEffect(() => {
  //   if (error?.code === 401) {
  //     logout();
  //   }
  // }, [error?.code, logout]); // Add logout to the dependency array

  useEffect(() => {
    if (error?.code === 401) {
      logout();
      setError({
        error: false,
        errorType: null,
        errorTitle: "",
        errorDescription: "",
      });
    }
  }, [error?.code, logout, setError]);

  const login = (data: any, identityData?: any) => {
    const { username, email, token } = data;
    localStorage.setItem("user", JSON.stringify(data));
    setUser({
      name: username,
      email: email,
      isAuthenticated: true,
      token: token,
    });

    if (identityData) {
      localStorage.setItem("identity", JSON.stringify(identityData));
      setIdentity(identityData);
    }
  };

  // const setErrorData = ({
  //   error,
  //   errorDescription,
  //   errorTitle,
  //   errorType,
  //   hide = false,
  // }: errorType) => {
  //   setError({ error, errorDescription, errorTitle, errorType, hide });
  // };
  const authContextValue: AuthContextType = {
    user,
    login,
    logout,
    error,
    setError,
    identity,
    setIdentity,
  };
  return (
    <AuthContext.Provider value={authContextValue}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
